import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import pinia from './store'

// 导入视口监听自定义指令
import { vIntersect } from './directives/vIntersect'

// 引入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 引入 animate.css（关于我们页面动画）
import 'animate.css'
// 引入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 引入埋点系统
import { mountTrackingToGlobal, CHANNEL_VISIT } from './utils/tracking'

import Vant from 'vant';

// 导入Vant组件和样式
import vantUI from 'vant'
import 'vant/lib/index.css'

import './style.css'
import 'vant/lib/index.css';

// 移动端调试工具Vconsole
import VConsole from 'vconsole';
// 仅在开发环境和测试环境使用
// if (import.meta.env.MODE !== 'production') {
//   new VConsole();
// }

// Fix mobile viewport height when virtual keyboard opens
function setFixedViewportHeight() {
  const initialHeight = window.innerHeight
  const setVar = (h) => {
    const vh = h * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }
  setVar(initialHeight)

  if (window.visualViewport) {
    // Only update for orientation/zoom changes; avoid reacting to keyboard height changes
    const onResize = () => {
      // Use the larger of initial and current to reduce jumps
      setVar(Math.max(initialHeight, window.visualViewport.height))
    }
    window.visualViewport.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', () => setTimeout(onResize, 300))
  } else {
    // Fallback
    window.addEventListener('orientationchange', () => setTimeout(() => setVar(window.innerHeight), 300))
  }
}

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用Pinia
app.use(pinia)
// 使用Router
app.use(router)
// 使用Element Plus
app.use(ElementPlus)

// Initialize viewport variable before mount
// setFixedViewportHeight()

app.use(Vant)

// 初始化埋点系统
mountTrackingToGlobal({
  debug: import.meta.env.DEV,
})

let channelCode = new URLSearchParams(window.location.search).get('channelSource');
// 上报渠道访问事件（进入官网首页）
window.trackImmediate(CHANNEL_VISIT, {
  elementId: 'home-page',
  elementDesc: '官网首页访问',
  channelCode,
})

// 注册视口监听自定义指令
app.directive('intersect', vIntersect)

app.mount('#app')
